module.exports = {
  // -- Prismic repository GraphQL endpoint
  apiEndpoint: 'https://servitours.prismic.io/graphql',
  defaultLanguage: 'fr-fr',
  langs: ['fr-fr', 'en-us'],
};
